<script>
    import gsap from 'gsap';
    import DrawSVGPlugin from 'gsap/DrawSVGPlugin';
    import {onMount, onDestroy} from "svelte";

    gsap.registerPlugin(DrawSVGPlugin);

    let displayNum = 0;

    function interpolate(start, target, durationMS) {
        if (start === target) {
            return;
        }

        const steps = target - start;
        const frameDuration = durationMS / steps;
        const newStart = start + 1;

        displayNum = newStart;

        setTimeout(() => interpolate(newStart, target, durationMS - frameDuration), frameDuration);
    }

    let drawLine;
    let tl = gsap.timeline();
    let svgElement;

    onMount(() => {
        tl.fromTo(drawLine, {
            drawSVG: "100% 100%",
            transformOrigin: 'center center',
        }, {
            drawSVG: "100% 0%",
            stagger: 0.15,
            duration: 1,
            onStart: () => {
                interpolate(0, 86, 1000)
            },
        });

        tl.play();
    });

    onDestroy(() => {
        tl.clear();
        tl = null;
    })
</script>

<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 380 678" bind:this={svgElement}>
    <defs>
        <clipPath id="clip-path">
            <rect id="Rectangle_504" data-name="Rectangle 504" width="195.569" height="201.63" fill="none"/>
        </clipPath>
    </defs>
    <rect id="Rectangle_863" data-name="Rectangle 863" width="380" height="678"/>
    <text id="of_business_leaders_say_they_are_applying_more_rigour_to_their_selection_of_partners"
          data-name="of business leaders say they are applying more rigour to their selection of partners"
          transform="translate(40 391)" fill="#fff" font-size="24" font-family="Metric">
        <tspan x="0" y="18">of business leaders say</tspan>
        <tspan x="0" y="46">they are applying more</tspan>
        <tspan x="0" y="74">rigour to their selection</tspan>
        <tspan x="0" y="102">of partners</tspan>
    </text>
    <text id="_86_" data-name="86%" transform="translate(100 225)" fill="#fff" font-size="86"
          font-family="Metric-Bold, Metric" font-weight="700">
        <tspan x="20" y="66" class="lif">{displayNum}%</tspan>
    </text>
    <text id="What_s_new_about_how_companies_select_strategic_partners_" data-name="What’s new about how
companies select
strategic partners?
" transform="translate(40 50.446)" fill="#fcd0b1" font-size="24" font-family="Metric">
        <tspan x="0" y="0">What’s new about how</tspan>
        <tspan x="0" y="28">companies select</tspan>
        <tspan x="0" y="56">strategic partners?</tspan>
        <tspan font-family="Metric-Semibold" font-weight="600">
            <tspan x="0" y="84"></tspan>
        </tspan>
    </text>
    <g id="Group_1039" data-name="Group 1039" transform="translate(92 157)">
        <g id="Group_1038" data-name="Group 1038" clip-path="url(#clip-path)">
            <path id="Path_14508" bind:this={drawLine} data-name="Path 14508"
                  d="M97.785,7.061A96.785,96.785,0,1,1,1,103.846C1,80.327,7.768,61.215,22.569,42.937" fill="none"
                  stroke="#469ed8" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14509" data-name="Path 14509" d="M92.541,6.6a5.4,5.4,0,1,1,5.4,5.4,5.4,5.4,0,0,1-5.4-5.4"
                  fill="#fff"/>
            <path id="Path_14510" data-name="Path 14510" d="M92.541,6.6a5.4,5.4,0,1,1,5.4,5.4A5.4,5.4,0,0,1,92.541,6.6Z"
                  fill="none" stroke="#100f0c" stroke-miterlimit="10" stroke-width="2.398"/>
        </g>
    </g>
</svg>